class BundleManager {

    constructor(options = {}) {
        this.bundleId    = options.bundleId || 'routine_bundle';
        this.currency    = '$';
        this.items       = new Map();

        this.cacheDom();

        this.requiredQty = parseInt(
            this.checkoutBtn?.dataset.minimumBundle, 10
        ) || 2;

        this.bindEvents();
        this.updateUI();
    }

     

    cacheDom() {
        this.bundleBar       = document.querySelector('.bundle-bar');
        this.countEl         = document.querySelector('.bundle-count');
        this.totalEl         = document.querySelector('.bundle-total');
        this.checkoutBtn     = document.querySelector('.bundle-checkout');
        this.imagesContainer = document.querySelector('.bundle-selected-images');
    }

 

    
    getCard(el) {
        return el.closest('.quick-view-custom') || el.closest('.product-item');
    }

    
    getCardQty(card) {
        const input = card.querySelector('.quantity__input');
        return input ? Math.max(1, parseInt(input.value, 10) || 1) : 1;
    }

     
    getTotalQty() {
        let total = 0;
        this.items.forEach(item => { total += item.quantity; });
        return total;
    }

     
    getVariantFromCard(card) {

        const button = card.querySelector('.bundle-add');
        if (button && button.dataset.variantId) {
            return {
                variantId: button.dataset.variantId,
                price: parseInt(button.dataset.price, 10) || 0
            };
        }
      
        const desktopSelect = card.querySelector('.bundle-variant-select');
        if (desktopSelect && desktopSelect.value) {
            const opt   = desktopSelect.options[desktopSelect.selectedIndex];
            const price = parseInt(opt?.dataset.price, 10) || 0;
            return { variantId: desktopSelect.value, price };
        }

         
        const qvSelect = card.querySelector('select[name="id"]');
        if (qvSelect && qvSelect.value) {
            const variantId   = qvSelect.value;
             
            const activeOpt   = card.querySelector(`.custom-variant-option.active`);
            const matchingOpt = card.querySelector(`.custom-variant-option[data-value="${variantId}"]`);
            const fallbackOpt = card.querySelector(`.custom-variant-option:not(.disabled)`);
            const priceSource = activeOpt || matchingOpt || fallbackOpt;
            const price       = parseInt(priceSource?.dataset.price, 10) || 0;
            return { variantId, price };
        }

         
        const hiddenInput = card.querySelector('input[name="id"]');
        if (hiddenInput && hiddenInput.value) {
            const button = card.querySelector('.bundle-add');
            const price  = parseInt(button?.dataset.price, 10) || 0;
            return { variantId: hiddenInput.value, price };
        }

        return { variantId: null, price: 0 };
    }

     
    getCardImage(card) {
        if (card.dataset.image) return card.dataset.image;
        const img = card.querySelector('.quickview-image img');
        return img ? img.getAttribute('src') : '';
    }

     
    _setButtonText(button, text) {
        const span = button.querySelector('span');
        if (span) span.textContent = text;
        else button.textContent = text;
    }

    _syncButtonState(button, variantId) {
        if (!button || !variantId) return;
        if (this.items.has(variantId)) {
            button.classList.add('selected');
            this._setButtonText(button, 'Remove');
        } else {
            button.classList.remove('selected');
            this._setButtonText(button, 'Add to Bundle');
        }
    }

     
    initQuickView(modal) {
        const list = modal.querySelector('.custom-variant-list');
        if (!list) return;

       
        const alreadyActive = list.querySelector('.custom-variant-option.active');
        if (!alreadyActive) {
            const first = list.querySelector('.custom-variant-option:not(.disabled)');
            if (first) first.classList.add('active');
        }

       
        const { variantId } = this.getVariantFromCard(modal);
        const button        = modal.querySelector('.bundle-add');
        if (button) this._syncButtonState(button, variantId);
    }

    

    bindEvents() {

         
        document.addEventListener('click', (e) => {
            const button = e.target.closest('.bundle-add');
            if (!button) return;
            e.preventDefault();
            e.stopPropagation();
            this.toggleItem(button);
        }, true);  

         
        document.addEventListener('click', (e) => {
            const option = e.target.closest('.custom-variant-option');
            if (!option || option.classList.contains('disabled')) return;

            const container = option.closest('.data-variant-container');
            if (!container) return;

            const variantId = option.dataset.value;

             
            container.querySelectorAll('.custom-variant-option')
                     .forEach(li => li.classList.remove('active'));
            option.classList.add('active');
            option.closest('.bundle-variant-selector')?.classList.remove('active');

             
            const select = container.querySelector(
                '.bundle-variant-select, select[name="id"]'
            );
            if (select) select.value = variantId;

             
            const label = container.querySelector('.selected-variant-title-cust');
            if (label) label.textContent = option.dataset.title;

             
            const card   = this.getCard(container);
            const button = card?.querySelector('.bundle-add');
            if (button) {
                button.dataset.variantId = variantId;
                button.dataset.price     = option.dataset.price;
                this._syncButtonState(button, variantId);
            }
        });

         
        document.addEventListener('click', (e) => {
            const btn = e.target.closest('.quantity__button');
            if (!btn) return;

            requestAnimationFrame(() => {
                const card = this.getCard(btn);
                if (!card) return;

                const { variantId } = this.getVariantFromCard(card);
                if (!variantId || !this.items.has(variantId)) return;

                const qty = this.getCardQty(card);
                this.items.get(variantId).quantity = qty;
                this.updateUI();
            });
        });

        
        document.addEventListener('click', (e) => {
                const trigger = e.target.closest('.Quick-view-open');
                if (!trigger) return;

                setTimeout(() => {
                    const card  = trigger.closest('.product-item');
                    const modal = card?.querySelector('.quick-view-custom.active')
                            || card?.querySelector('.quick-view-custom');
                    if (modal) this.initQuickView(modal);
                }, 100);
        });

         
        if (this.checkoutBtn) {
            this.checkoutBtn.addEventListener('click', () => {
                if (!this.checkoutBtn.disabled) this.addToCart();
            });
        }
    }

     

    toggleItem(button) {
        const card = this.getCard(button);
        if (!card) return;

        const { variantId, price } = this.getVariantFromCard(card);

        // console.log('[Bundle] toggleItem →', { variantId, price, card });

        if (!variantId) {
            // console.warn('[Bundle] No variantId found — check getVariantFromCard()');
            return;
        }

        if (this.items.has(variantId)) {
            this.removeItem(variantId);
        } else {
            const qty = this.getCardQty(card);
            this.addItem(variantId, button, card, price, qty);
        }

        this.updateUI();
    }

    addItem(variantId, button, card, price, quantity = 1) {
        this.items.set(variantId, {
            image: this.getCardImage(card),
            button,
            price,
            quantity,
        });
        button.classList.add('selected');
        this._setButtonText(button, 'Remove');

          
        const quickView = button.closest('.quick-view-custom');
        if (quickView) {
            quickView.classList.remove('active');
        }
    }

    removeItem(variantId) {
        const item = this.items.get(variantId);
        if (item?.button) {
            item.button.classList.remove('selected');
            this._setButtonText(item.button, 'Add to Bundle');
             const quickView = item.button.closest('.quick-view-custom');
            if (quickView) {
                quickView.classList.remove('active');
            }
        }
        this.items.delete(variantId);
        
    }

    

    updateUI() {
        const totalQty = this.getTotalQty();

        if (this.countEl) this.countEl.textContent = totalQty;

        this.updateTotal();

        if (this.checkoutBtn) {
            const remaining = this.requiredQty - totalQty;
            if (remaining > 0) {
                this.checkoutBtn.disabled    = true;
                this.checkoutBtn.textContent = `Add ${remaining} more item${remaining !== 1 ? 's' : ''}`;
            } else {
                this.checkoutBtn.disabled    = false;
                this.checkoutBtn.textContent = 'Add Bundle to Cart';
            }
        }

        this.renderImages();
    }

    updateTotal() {
        let totalCents = 0;
        this.items.forEach(item => { totalCents += item.price * item.quantity; });
        if (this.totalEl) this.totalEl.textContent = this.formatMoney(totalCents);
    }

    formatMoney(cents) {
        return this.currency + (cents / 100).toFixed(2);
    }

    renderImages() {
        if (!this.imagesContainer) return;
        this.imagesContainer.innerHTML = '';

        this.items.forEach((item) => {
            if (!item.image) return;

            const wrap = document.createElement('div');
            wrap.style.cssText = 'position:relative;display:inline-block;margin-right:8px;';

            const img         = document.createElement('img');
            img.src           = item.image;
            img.className     = 'bundle-thumb';
            img.style.cssText = 'width:40px;height:40px;object-fit:cover;display:block;border-radius:4px;';

            if (item.quantity > 1) {
                const badge         = document.createElement('span');
                badge.textContent   = `×${item.quantity}`;
                badge.style.cssText = `
                    position:absolute;top:-6px;right:-6px;
                    background:#000;color:#fff;border-radius:50%;
                    font-size:10px;width:18px;height:18px;
                    display:flex;align-items:center;justify-content:center;line-height:1;
                `;
                wrap.appendChild(badge);
            }

            wrap.appendChild(img);
            this.imagesContainer.appendChild(wrap);
        });
    }

    

    resetBundle() {
        this.items.forEach(item => {
            if (item.button) {
                item.button.classList.remove('selected');
                this._setButtonText(item.button, 'Add to Bundle');
            }
        });
        this.items.clear();
        this.updateUI();
    }

     

    async addToCart() {
        if (this.getTotalQty() < this.requiredQty) return;

        const itemsPayload = Array.from(this.items.entries()).map(([variantId, item]) => ({
            id:         variantId,
            quantity:   item.quantity,
            properties: { _bundle_id: this.bundleId }
        }));

        try {
            this.checkoutBtn.disabled    = true;
            this.checkoutBtn.textContent = 'Adding…';

            const response = await fetch('/cart/add.js', {
                method:  'POST',
                headers: { 'Content-Type': 'application/json' },
                body:    JSON.stringify({ items: itemsPayload })
            });

            if (!response.ok) throw new Error('Cart add failed');

            await this.openCartDrawer();
            setTimeout(() => this.resetBundle(), 1000);

        } catch (error) {
            console.error('[Bundle] Cart error:', error);
            this.checkoutBtn.disabled    = false;
            this.checkoutBtn.textContent = 'Add Bundle to Cart';
        }
    }

    async openCartDrawer() {
        const drawer = document.querySelector('cart-drawer');
        if (drawer) drawer.loadContent(true);
    }
}

 

document.addEventListener('DOMContentLoaded', () => {
    if (!document.body.classList.contains('template-collection-bundle-and-save')) return;
    new BundleManager({ bundleId: 'routine_bundle' });
});

$(document).on('click', '.bundle-mobile-open', function () {
    $(this).closest('.product-item').find('.Quick-view-open').trigger('click');
});
